import Colors from '@omni/kit/theming/Colors';
import Spacing from '@omni/kit/theming/Spacing';
import React from 'react';
import { StyleProp, StyleSheet, View, ViewStyle } from 'react-native';

import KitText from '../KitText';

export default function KitDividerWithText({
  text,
  style,
}: {
  text: string;
  style?: StyleProp<ViewStyle>;
}): JSX.Element {
  return (
    <View style={[styles.dividerContainer, style]}>
      <View style={styles.dividerLine} />
      <KitText style={styles.dividerText}>{text}</KitText>
      <View style={styles.dividerLine} />
    </View>
  );
}

const styles = StyleSheet.create({
  dividerContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
  },
  dividerLine: {
    flex: 1,
    borderBottomColor: Colors.N100,
    borderBottomWidth: 1,
  },
  dividerText: {
    fontSize: 14,
    paddingHorizontal: Spacing.s,
  },
});
